import Immutable from 'seamless-immutable';

export default () =>
  Immutable({
    __record: 'UploadQueueRecord',
    queueIds: [], // a representation of the uploader queued items
    queueItems: {},
    simulatedQueue: false, // true in case need to show upload queue but no upload files yet (client batch)
    retryIds: [],
    abortIds: [],
    added: { files: [], cropInfo: [] }, // used to add new file(s) to the queue programmatically
    addValidationError: null,
  });
